var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-md is-ghost btn-block",class:[{ 'is-loading': _vm.loading }, _vm.buttonSizeClass],on:{"click":_vm.deleteAnonymizationRequest}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }